import request from '@/router/axios'

export function getScreenIndex(obj) {
  return request({
    url: '/api/screenkaihu/index',
    method: 'post',
    data: obj
  })
}

export function getPageIndex(obj) {
  return request({
    url: '/api/screen/getanalysedata',
    method: 'post',
    data: obj
  })
}

export function getMapCityIndex_new(obj) {
  return request({
    url: '/api/screenkaihu/getcitydata_new',
    method: 'post',
    data: obj
  })
}

export function getMapCityIndex(obj) {
  return request({
    url: '/api/screenkaihu/getcitydata',
    method: 'post',
    data: obj
  })
}

export function getCityBankData(obj) {
  return request({
    url: '/api/screenkaihu/getcitybankdata',
    method: 'post',
    data: obj
  })
}

export function getCityBankData_new(obj) {
  return request({
    url: '/api/screenkaihu/getcitybankdata_new',
    method: 'post',
    data: obj
  })
}


export function getMapJson(obj) {
  return request({
    url: `/api/screenkaihu/get_map_json`,
    method: 'post',
    data: obj
  })
}

export function getUserData(obj) {
  return request({
    url: '/api/screen/getuserlist',
    method: 'post',
    data: obj
  })
}


export function getVipNum(obj) {
  return request({
    url: '/api/screen/getuserdata',
    method: 'post',
    data: obj
  })
}

export function useractive_rank(obj) {
  return request({
    url: '/api/screen/useractive_rank',
    method: 'post',
    data: obj
  })
}

export function getiptoprovince_new(obj) {
  return request({
    url: '/api/screenkaihu/getprovincedata_new',
    method: 'post',
    data: obj
  })
}

export function getiptoprovince(obj) {
  return request({
    url: '/api/screenkaihu/getprovincedata',
    method: 'post',
    data: obj
  })
}

export function screen_login(obj) {
  return request({
    url: '/api/screen/screen_login',
    method: 'post',
    data: obj
  })
}

export function aiAskList(obj) {
  return request({
    url: '/api/screen/get_gptdata',
    method: 'post',
    data: obj
  })
}


export function getKaihuList(obj) {
  return request({
    url: '/api/screenkaihu/getdaydata_line',
    method: 'post',
    data: obj
  })
}


export function getKaihuCityList(obj) {
  return request({
    url: '/api/screenkaihu/getcitydata_line_new',
    method: 'post',
    data: obj
  })
}

export function getCityList(obj) {
  return request({
    url: '/api/resevation/city_list',
    method: 'post',
    data: obj
  })
}


export function getKaihuMonthList(obj) {
  return request({
    url: '/api/screenkaihu/getyeardata_line',
    method: 'post',
    data: obj
  })
}



export function getKaihuMonthCityList(obj) {
  return request({
    url: '/api/screenkaihu/getyearcitydata_line_new',
    method: 'post',
    data: obj
  })
}

export function getCityDataNew(obj) {
  return request({
    url: '/api/screenkaihu/getyearcitydata_new',
    method: 'post',
    data: obj
  })
}

export function getdaycitydata_new(obj) {
  return request({
    url: '/api/screenkaihu/getdaycitydata_new',
    method: 'post',
    data: obj
  })
}

export function get_bank_type(obj) {
  return request({
    url: '/api/screenkaihu/get_bank_type',
    method: 'post',
    data: obj
  })
}


